<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ 'employees.title' | translate }}</h2>
      <p class="page-sub">
        {{ 'employees.subtitle' | translate }}
      </p>
    </div>
    <span class="spacer"></span>
    <button mat-flat-button color="primary" (click)="add()" *ngIf="canEdit">
      <mat-icon>person_add</mat-icon> {{ 'employees.add' | translate }}
    </button>
  </div>

  <div class="toolbar">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="search" (ngModelChange)="recompute()" [placeholder]="'employees.searchPlaceholder' | translate">
      <button mat-icon-button matSuffix *ngIf="search" (click)="search = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>{{ 'employees.status' | translate }}</mat-label>
      <mat-select [(ngModel)]="statusFilter" (ngModelChange)="recompute()">
        <mat-option value="all">{{ 'employees.statusAll' | translate }}</mat-option>
        <mat-option value="active">{{ 'employees.statusActive' | translate }}</mat-option>
        <mat-option value="inactive">{{ 'employees.statusInactive' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field" *ngIf="groups.length > 1">
      <mat-label>{{ 'employees.group' | translate }}</mat-label>
      <mat-select [(ngModel)]="groupFilter" (ngModelChange)="recompute()">
        <mat-option value="">{{ 'employees.allGroups' | translate }}</mat-option>
        <mat-option *ngFor="let g of groups" [value]="g.id">{{ g.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <span class="spacer"></span>
    <span class="pill">{{ 'employees.activeOfTotal' | translate:{active: activeCount, total: employees.length} }}</span>
    <button mat-stroked-button (click)="exportCsv()" [disabled]="!filtered.length">
      <mat-icon>download</mat-icon> {{ 'employees.export' | translate }}
    </button>
  </div>

  <div class="state" *ngIf="loading">{{ 'employees.loading' | translate }}</div>
  <div class="state error" *ngIf="error">{{ error }}</div>

  <div class="table-wrap" *ngIf="!loading && !error">
    <table class="data">
      <thead>
        <tr>
          <th>{{ 'employees.colName' | translate }}</th>
          <th>{{ 'employees.colEmail' | translate }}</th>
          <th>{{ 'employees.colEmployeeNo' | translate }}</th>
          <th>{{ 'employees.colGroup' | translate }}</th>
          <th class="num">{{ 'employees.colCredit' | translate }}</th>
          <th>{{ 'employees.colStatus' | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let e of filtered" [class.row-off]="!e.status">
          <td>{{ e.name || '—' }}</td>
          <td>{{ e.email || '—' }}</td>
          <td>{{ e.employeeCode || '—' }}</td>
          <td>{{ e.groupName || '—' }}</td>
          <td class="num">
            <a class="link" (click)="openLedger(e)" [matTooltip]="'employees.tipShowCredit' | translate">kr {{ kr(e.credit) }}</a>
          </td>
          <td>
            <span class="pill pill-green" *ngIf="e.status">{{ 'employees.active' | translate }}</span>
            <span class="pill pill-grey" *ngIf="!e.status">{{ 'employees.deactivated' | translate }}</span>
          </td>
          <td class="row-actions">
            <ng-container *ngIf="canEdit">
              <button mat-icon-button (click)="edit(e)" [disabled]="busy[e.membershipId]" [matTooltip]="'employees.tipEdit' | translate">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button (click)="sendReset(e)" [disabled]="busy[e.membershipId] || !e.email"
                      [matTooltip]="'employees.tipReset' | translate">
                <mat-icon>mail</mat-icon>
              </button>
              <button mat-icon-button *ngIf="e.status" (click)="setStatus(e, false)"
                      [disabled]="busy[e.membershipId]" [matTooltip]="'employees.tipDeactivate' | translate">
                <mat-icon>block</mat-icon>
              </button>
              <button mat-icon-button *ngIf="!e.status" (click)="setStatus(e, true)"
                      [disabled]="busy[e.membershipId]" [matTooltip]="'employees.tipReactivate' | translate">
                <mat-icon>undo</mat-icon>
              </button>
              <button mat-icon-button [matMenuTriggerFor]="rowMenu" [disabled]="busy[e.membershipId]">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #rowMenu="matMenu">
                <button mat-menu-item (click)="openLedger(e)">
                  <mat-icon>history</mat-icon> {{ 'employees.tipCreditHistory' | translate }}
                </button>
                <button mat-menu-item (click)="remove(e)">
                  <mat-icon>delete_outline</mat-icon> {{ 'employees.tipRemove' | translate }}
                </button>
              </mat-menu>
            </ng-container>
            <button mat-icon-button *ngIf="!canEdit" (click)="openLedger(e)" [matTooltip]="'employees.tipCreditHistory' | translate">
              <mat-icon>history</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="state" *ngIf="!filtered.length && employees.length">
      {{ 'employees.noMatches' | translate }}
    </div>
    <div class="state" *ngIf="!employees.length">
      {{ 'employees.emptyPrefix' | translate }} <strong>{{ 'employees.add' | translate }}</strong> {{ 'employees.emptySuffix' | translate }}
    </div>
  </div>
</div>
